module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAKCAYAAACJxx+AAAAAtklEQVQoU62QsQ7BYBSFz/lTVTF4DWo3GSRiMxI1GM3ESmKzG9kMop0MNjYPUV7BI9D4j5CQMrvTzc2Xc/MdIjVJpziyxhSym3j6PjMNXLv+jELeDePBHwEBJKBn5O8L1eDw1vUv1tqeF533aSBp+1U52DEJ/LqoLcSGoCYgj/f7mo5ztJa9l8U1KLdILSAdBLiGqAgau5vz6qN5C4p90CxfelZDNzrNn+t3D0FpYsBcJozH7x4e+CZSgzhTPnEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/charter/screen_icon_jiang.png
// module id = QBMC
// module chunks = 1